import { Controller } from "@hotwired/stimulus";

// Drag-and-drop + click file selection for the bank statement upload.
// Dropped files are assigned back to the native input so the form submits them normally.
export default class extends Controller {
  static targets = ["input", "dropzone", "placeholder", "preview", "filename"];

  browse(event) {
    event.preventDefault();
    this.inputTarget.click();
  }

  fileSelected() {
    this.renderPreview(this.inputTarget.files);
  }

  clear(event) {
    event.preventDefault();
    this.inputTarget.value = "";
    this.renderPreview(null);
  }

  dragover(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.add("dragover");
  }

  dragleave(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove("dragover");
  }

  drop(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove("dragover");

    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      this.inputTarget.files = files;
      this.renderPreview(files);
    }
  }

  renderPreview(files) {
    if (files && files.length > 0) {
      this.filenameTarget.textContent = files[0].name;
      this.placeholderTarget.classList.add("d-none");
      this.previewTarget.classList.remove("d-none");
      this.previewTarget.classList.add("d-flex");
    } else {
      this.placeholderTarget.classList.remove("d-none");
      this.previewTarget.classList.add("d-none");
      this.previewTarget.classList.remove("d-flex");
    }
  }
}
